var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { IndexContext } from "../lib/IndexContext.js";
import { useIndex } from "../lib/useIndex.js";
export function Index(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var index = useIndex(props);
  if (index.getHelper() === null) {
    return null;
  }
  return /*#__PURE__*/React.createElement(IndexContext.Provider, {
    value: index
  }, children);
}